import { render, staticRenderFns } from "./phy.vue?vue&type=template&id=a92e3092&scoped=true&"
import script from "./phy.vue?vue&type=script&lang=ts&"
export * from "./phy.vue?vue&type=script&lang=ts&"
import style0 from "./phy.vue?vue&type=style&index=0&id=a92e3092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92e3092",
  null
  
)

export default component.exports